import styled from "styled-components";

import { PartnerBankColors } from "@ctypes";

export const Page = styled.div<{ $colors: PartnerBankColors }>`
  position: relative;
  overflow: hidden;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 76px 24px 64px;
  background: ${({ $colors }) =>
    `linear-gradient(180deg, ${$colors.gradientStart} ${$colors.gradientStartOffset * 100}%, ${
      $colors.gradientEnd
    } ${$colors.gradientEndOffset * 100}%)`};
`;

export const Watermark = styled.div`
  position: absolute;
  pointer-events: none;
`;

export const Badge = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
  border-radius: 100px;
  border: 1px solid rgba(255, 255, 255, 0.22);
  background: rgba(255, 255, 255, 0.1);
  padding: 6px 20px;
  color: #ffffff;
  font-size: 14px;
  font-weight: 600;
`;

export const Separator = styled.span`
  font-size: 15px;
  opacity: 0.8;
`;

export const Title = styled.h1`
  position: relative;
  margin: 44px 0 0;
  max-width: 520px;
  text-align: center;
  font-family: "Playfair Display", serif;
  font-weight: 600;
  font-size: 34px;
  line-height: 1.35;
  color: #f4f1f2;

  @media (max-width: 720px) {
    font-size: 26px;
  }
`;

export const TitleHighlight = styled.span<{ $color: string }>`
  color: ${({ $color }) => $color};
`;

export const Subtitle = styled.p`
  position: relative;
  margin: 18px 0 0;
  max-width: 420px;
  text-align: center;
  font-size: 14px;
  line-height: 1.63;
  color: rgba(255, 255, 255, 0.8);
`;

export const PrimaryCta = styled.button<{ $colors: PartnerBankColors }>`
  position: relative;
  margin-top: 44px;
  border: 0;
  cursor: pointer;
  width: 304px;
  max-width: 100%;
  border-radius: 45px;
  padding: 15px;
  font-size: 18px;
  font-weight: 700;
  background: ${({ $colors }) => $colors.cta};
  color: ${({ $colors }) => $colors.ctaText};
`;

export const Dismiss = styled.button`
  position: relative;
  margin-top: 18px;
  border: 0;
  background: none;
  cursor: pointer;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.8);
`;

export const Disclaimer = styled.p`
  position: relative;
  margin: 30px 0 0;
  max-width: 420px;
  text-align: center;
  font-size: 11px;
  line-height: 1.3;
  color: rgba(255, 255, 255, 0.6);
`;
